export default (theme) => ({
  // ----------------------------------- compatible for new design
  title72: {
    fontSize: '72px',
    lineHeight: '96px',
    fontWeight: 600,
  },
  title64: {
    fontSize: '64px',
    lineHeight: '80px',
    fontWeight: 600,
  },
  heading56: {
    fontSize: '56px',
    lineHeight: '64px',
    fontWeight: 600,
  },
  heading48: {
    fontSize: '48px',
    lineHeight: '56px',
    fontWeight: 600,
  },
  heading40: {
    fontSize: '40px',
    lineHeight: '48px',
    fontWeight: 600,
  },
  heading24: {
    fontSize: '24px',
    fontWeight: 600,
  },
  heading22: {
    fontSize: '22px',
    fontWeight: 600,
  },
  subheading32: {
    fontSize: '32px',
    lineHeight: '40px',
    fontWeight: 600,
  },
  subheading30: {
    fontSize: '30px',
    lineHeight: '40px',
    fontWeight: 600,
  },
  subheading24: {
    fontSize: '24px',
    lineHeight: '32px',
    fontWeight: 600,
  },
  subheading22: {
    fontSize: '22px',
    lineHeight: '24px',
    fontWeight: 600,
  },
  subheading20: {
    fontSize: '20px',
    lineHeight: '24px',
    fontWeight: 600,
  },
  subheading18: {
    fontSize: '18px',
    lineHeight: '24px',
    fontWeight: 600,
  },
  subheading16: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 600,
  },
  subheader11: {
    fontSize: '11px',
    fontWeight: 600,
  },
  bodysubheading20: {
    fontSize: '20px',
    lineHeight: '24px',
    fontWeight: 500,
  },
  bodytext20: {
    fontSize: '20px',
    lineHeight: '32px',
  },
  bodytext18: {
    fontSize: '18px',
    lineHeight: '24px',
  },
  bodytextmedium18: {
    fontSize: '18px',
    lineHeight: '24px',
    fontWeight: 500,
  },
  bodytext16: {
    fontSize: '16px',
    lineHeight: '24px',
  },
  bodytextbold16: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 600,
  },
  bodytextmedium16: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 500,
  },
  bodytext14: {
    fontSize: '14px',
    lineHeight: '24px',
    fontWeight: 400,
  },
  bodytextbold14: {
    fontSize: '14px',
    lineHeight: '24px',
    fontWeight: 600,
  },
  bodytextmedium14: {
    fontSize: '14px',
    lineHeight: '24px',
    fontWeight: 500,
  },
  caption12: {
    fontSize: '12px',
    lineHeight: '14px',
  },
  captionmedium12: {
    fontSize: '12px',
    lineHeight: '14px',
    fontWeight: 500,
  },
  captionsemibold12: {
    fontSize: '12px',
    lineHeight: '14px',
    fontWeight: 600,
  },
  captionbold12: {
    fontSize: '12px',
    lineHeight: '14px',
    fontWeight: 700,
  },
  metadata10: {
    fontSize: '10px',
    lineHeight: '12px',
  },
  metadatamedium10: {
    fontSize: '10px',
    lineHeight: '12px',
    fontWeight: 500,
  },
  metadatabold10: {
    fontSize: '10px',
    lineHeight: '12px',
    fontWeight: 600,
  },

  // ----------------------------------- compatible for old design
  xHeading16: {
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: 800,
    letterSpacing: 0.3,
  },
  xSubheading28: {
    fontSize: '28px',
    lineHeight: '40px',
    fontWeight: 600,
  },
  xSubheading24: {
    fontSize: '24px',
    lineHeight: '30px',
    fontWeight: 600,
  },
  xSubheading18: {
    fontSize: '18px',
    lineHeight: '23px',
    fontWeight: 600,
  },
  xSubheading14: {
    fontSize: '14px',
    lineHeight: '18px',
    fontWeight: 600,
  },
  xTextbody16: {
    fontSize: '16px',
    lineHeight: '20.24px',
    fontWeight: 400,
  },
  xTextbody14: {
    fontSize: '14px',
    lineHeight: '17.71px',
    fontWeight: 400,
  },
  xTextbody12: {
    fontSize: '12px',
    lineHeight: '15.18px',
    fontWeight: 400,
  },
  // ----------------------------------- revamp dashboard
  h1: {
    fontSize: '40px',
    lineHeight: '48px',
    fontWeight: 600,
  },
  h2: {
    fontSize: '32px',
    lineHeight: '40px',
    fontWeight: 600,
  },
  h3: {
    fontSize: '28px',
    lineHeight: '38px',
    fontWeight: 600,
  },
  h4: {
    fontSize: '24px',
    lineHeight: '32px',
    fontWeight: 600,
  },
  subheading1: {
    fontSize: '20px',
    lineHeight: '26px',
    fontWeight: 600,
  },
  subheading2: {
    fontSize: '18px',
    lineHeight: '26px',
    fontWeight: 600,
  },
  subheading3: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 600,
  },
  subheading3medium: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 500,
  },
  subheading4: {
    fontSize: '14px',
    lineHeight: '24px',
    fontWeight: 600,
  },
  subheading4medium: {
    fontSize: '14px',
    lineHeight: '24px',
    fontWeight: 500,
  },
  bodytext1: {
    fontSize: '18px',
    lineHeight: '26px',
    fontWeight: 400,
  },
  paragraph: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 400,
  },
  paragraph2: {
    fontSize: '14px',
    lineHeight: '24px',
    fontWeight: 400,
  },
  caption1: {
    fontSize: '12px',
    lineHeight: '20px',
    fontWeight: 600,
  },
  captionreguler: {
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: 400,
  },
  metatag1: {
    fontSize: '10px',
    lineHeight: '14px',
    fontWeight: 600,
  },
  metatagreguler: {
    fontSize: '10px',
    lineHeight: '14px',
    fontWeight: 400,
  },
});
